export const editTypeAlt = 'edit type';
export const captureTypeAlt = 'capture type';
export const serviceTypeAndStage = 'service type & stage';
export const photoshoot = 'Photoshoot';
export const photoshootDescription = 'For any service that a technician is required to be on-site to perform. Will allow discarding during proofing.';
export const edit = 'Edit';
export const editDescription = 'For any service that is editing only. Will require payment for all photos during proofing.';
